export default __webpack_public_path__ + "static/media/slant and portrait.1eeeb5ad.png";